import React, { useState} from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { ConnectionProvider} from '@solana/wallet-adapter-react';
import { clusterApiUrl } from '@solana/web3.js';

import 'bootstrap/dist/css/bootstrap.min.css';
import '@solana/wallet-adapter-react-ui/styles.css'; // 必須
import theme from './theme';
import Header from './pages/Header';
import Home from './pages/Home';
import UploadForm from './pages/UploadForm';
import PaperEvaluationForm from './pages/PaperEvaluationForm';
import MessageDialog from './pages/MessageDialog';

import RandomEquationBackground from './components/RandomEquationBackground';

import StarryBackground from './pages/StarryBackground';
import ExploreList from './pages/ExploreList';
import MyPapers from './pages/MyPapers';
import NotFound from './pages/NotFound';
import DetailPage from './pages/Detail';
import einstenArt from './joke/einsteinArt';
import ProtectedRoute from './context/ProtectedRoute';
import { useBalance } from './context/BalanceContext';
import InsufficientBalancePage from './pages/InsufficientBalancePage';
import NotConnect from './pages/NotConnect';
import ScrollToTop from './components/ScrollToTop';
import WhatsEMCII from './pages/WhatsEMCII';
import Math from './pages/MathQuiz'
import OfficialRewards from './pages/OfficialRewards';
import OfficialRewardDetail from './pages/OfficialRewardDetail';
function App() {
  const network = clusterApiUrl("mainnet-beta"); // devnetを使用
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {tokenBalance} = useBalance();


  return (
    <ThemeProvider theme={theme}>
       <div
      dangerouslySetInnerHTML={{ __html: einstenArt }}
      style={{ fontFamily: 'monospace', whiteSpace: 'pre',height:0 }}
    />
       
      <ConnectionProvider endpoint={network}>
       
          <div style={{ position: "relative", minHeight: "100vh", paddingTop: "64px" }}>
              <Router>
              <ScrollToTop />
                <Header />
                <MessageDialog />
                <Routes>
                
                  <Route path="/" element={
                    <>
                    <RandomEquationBackground />
                  <Home />
                  </>
                } />
               <Route path="/explore" element={
                 <>
                 <RandomEquationBackground />
                 <ExploreList />
                 </>
               } />
               
               <Route path="/my-papers" element={

               <ProtectedRoute>
                 <RandomEquationBackground />
               <MyPapers />
               </ProtectedRoute>
               } />
               
             <Route path="/submit_form" element={<>
              <ProtectedRoute>
              <StarryBackground />
                <div style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "rgba(0, 0, 0, 0.8)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 10,
                }}>
                  <UploadForm onClose={() => setIsModalOpen(false)} />
                </div>
                </ProtectedRoute>
             </>} />

             <Route path="/evaluation" element={<>
              <StarryBackground />
                <div style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "rgba(0, 0, 0, 0.8)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 10,
                }}>
                  <PaperEvaluationForm onClose={() => setIsModalOpen(false)} />
                </div>
             </>} />
             <Route path="/paper/:id" element={
               <>
               <RandomEquationBackground />
             <DetailPage />
             </>
             } />
             
             <Route path="/whats-emcii" element={<WhatsEMCII />} />
             <Route path="/insufficient-balance" element={<InsufficientBalancePage />}/>
             <Route path="/not-connected" element={<NotConnect />} />
             <Route path="*" element={<NotFound />} />
             <Route path="/official-rewards" element={<OfficialRewards />} />
             <Route path="/reward/:id" element={
               <OfficialRewardDetail />
             } />
             </Routes>
              </Router>
            </div>
         
      </ConnectionProvider>
    </ThemeProvider>
  );
}





export default App;
